export const PeriodontalFindingsIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line
        x1="6.05603"
        y1="6.38855"
        x2="18.2794"
        y2="18.6119"
        stroke="#FF8A1E"
        strokeWidth="3.14298"
      />
      <rect
        x="0.5"
        y="7.5"
        width="9.42894"
        height="9.42894"
        rx="0.928086"
        transform="rotate(-45 0.5 7.5)"
        fill="#FF8A1E"
      />
    </svg>
  );
};
